"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpoints = createEndpoints;
const admin_1 = require("./endpoints/admin");
const announcements_1 = require("./endpoints/announcements");
const attendances_1 = require("./endpoints/attendances");
const attendees_1 = require("./endpoints/attendees");
const auth_1 = require("./endpoints/auth");
const cards_1 = require("./endpoints/cards");
const events_1 = require("./endpoints/events");
const interests_1 = require("./endpoints/interests");
const invitations_1 = require("./endpoints/invitations");
const maps_1 = require("./endpoints/maps");
const meetings_1 = require("./endpoints/meetings");
const organizations_1 = require("./endpoints/organizations");
const panel_commerce_1 = require("./endpoints/panel-commerce");
const plans_1 = require("./endpoints/plans");
const platform_1 = require("./endpoints/platform");
const post_event_1 = require("./endpoints/post-event");
const program_1 = require("./endpoints/program");
const staff_1 = require("./endpoints/staff");
const users_1 = require("./endpoints/users");
const wallet_1 = require("./endpoints/wallet");
/**
 * Uç nokta sarmalayıcıları — BARREL.
 *
 * Sagalar YALNIZCA bunları çağırır; bileşenler doğrudan API çağırmaz
 * (CLAUDE.md web/mobil kuralları). Yol dizgileri yalnız `endpoints/*.ts`
 * içinde geçer; ikinci bir çağrı deseni (`client.call` doğrudan) açılmaz.
 *
 * Yol, metot ve yanıt tipleri OpenAPI şemasından gelir: controller'da yol veya
 * metot değişirse alan modülünde DERLEME HATASI oluşur.
 *
 * BÖLME (Blok 28, tech-lead kararı (a)): tek dosya 1197 satıra çıkmıştı ve
 * `file-size-ceiling.guard` onu dondurmuştu — yani yeni bir uç eklenemiyordu.
 * Alan grupları `endpoints/<alan>.ts`'e taşındı; `Endpoints` tipi ve çağrı
 * yüzeyi (`endpoints.<alan>.<uç>`) AYNEN korundu, web/mobilde tek satır
 * değişmedi.
 *
 * YENİ ALAN EKLERKEN: (1) `endpoints/<alan>.ts` yaz, (2) aşağıdaki spread'e
 * ekle, (3) `endpoints.spec.ts` içindeki `DECLARED_DOMAINS`e yaz. Üçüncüsü
 * unutulursa test KIRILIR (alan grubu barrel'dan sessizce düşemez).
 */
function createEndpoints(client) {
    return {
        ...(0, platform_1.createPlatformEndpoints)(client),
        ...(0, auth_1.createAuthEndpoints)(client),
        ...(0, users_1.createUsersEndpoints)(client),
        ...(0, interests_1.createInterestsEndpoints)(client),
        ...(0, events_1.createEventsEndpoints)(client),
        ...(0, program_1.createProgramEndpoints)(client),
        ...(0, attendances_1.createAttendancesEndpoints)(client),
        ...(0, attendees_1.createAttendeesEndpoints)(client),
        ...(0, plans_1.createPlansEndpoints)(client),
        ...(0, invitations_1.createInvitationsEndpoints)(client),
        ...(0, organizations_1.createOrganizationsEndpoints)(client),
        ...(0, maps_1.createMapsEndpoints)(client),
        ...(0, meetings_1.createMeetingsEndpoints)(client),
        ...(0, announcements_1.createAnnouncementsEndpoints)(client),
        ...(0, post_event_1.createPostEventEndpoints)(client),
        ...(0, cards_1.createCardsEndpoints)(client),
        ...(0, wallet_1.createWalletEndpoints)(client),
        ...(0, admin_1.createAdminEndpoints)(client),
        ...(0, panel_commerce_1.createPanelCommerceEndpoints)(client),
        ...(0, staff_1.createStaffEndpoints)(client),
    };
}
//# sourceMappingURL=endpoints.js.map